import { Controller } from "@hotwired/stimulus"

// Controller for managing amendment form interactions
// Handles template loading for amendments
export default class extends Controller {
  static targets = ["templateSelect", "contentEditor"]
  static values = { staffContractId: Number }

  connect() {
    console.log("Amendment form controller connected")
  }

  // Find the TinyMCE editor for the content textarea
  getEditor() {
    // Try to find editor by the content textarea
    if (this.hasContentEditorTarget) {
      const textareaId = this.contentEditorTarget.id
      if (textareaId && typeof tinymce !== 'undefined') {
        return tinymce.get(textareaId)
      }
    }

    // Fallback: find any editor in this form
    if (typeof tinymce !== 'undefined') {
      const textarea = this.element.querySelector('textarea.tinymce-editor')
      if (textarea && textarea.id) {
        return tinymce.get(textarea.id)
      }
      // Last fallback: use active editor
      return tinymce.activeEditor
    }

    return null
  }

  // Load template content into the editor
  async loadTemplate(event) {
    event.preventDefault()

    const templateSelect = this.templateSelectTarget
    const templateId = templateSelect.value

    // If no template selected
    if (!templateId) {
      if (event.type === 'click') {
        alert("Veuillez selectionner un modele")
      } else {
        // Clear editor when selecting empty option
        const editor = this.getEditor()
        if (editor) {
          editor.setContent('')
        } else {
          const textarea = this.element.querySelector('textarea[name*="content"]')
          if (textarea) {
            textarea.value = ''
          }
        }
      }
      return
    }

    // Get current locale from URL
    const locale = window.location.pathname.split('/')[1] || 'fr'

    // Get staff contract ID from URL
    const pathParts = window.location.pathname.split('/')
    const staffContractsIndex = pathParts.indexOf('staff_contracts')
    const staffContractId = staffContractsIndex >= 0 ? pathParts[staffContractsIndex + 1] : null

    try {
      let url = `/${locale}/schools/rh/contracts/staff_contracts/${staffContractId}/amendments/load_template?template_id=${templateId}`

      console.log("Loading amendment template from:", url)

      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        const errorText = await response.text()
        console.error('Server error:', errorText)
        throw new Error('Failed to load template')
      }

      const data = await response.json()
      console.log("Template data received:", data)

      // Insert content into TinyMCE editor
      const editor = this.getEditor()
      if (editor) {
        editor.setContent(data.content || '')
        console.log("Template content set in TinyMCE editor")
      } else {
        // Fallback to textarea
        const textarea = this.element.querySelector('textarea[name*="content"]')
        if (textarea) {
          textarea.value = data.content || ''
          console.log("Template content set in textarea (fallback)")
        } else {
          console.warn("No editor or textarea found to set content")
        }
      }

      console.log("Amendment template loaded successfully")
    } catch (error) {
      console.error('Error loading template:', error)
      alert("Erreur lors du chargement du modele")
    }
  }
}
